import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { initAscDataLayer } from "./ascDataLayer";

export default function AscRoot({ children }) {
  const data = useStaticQuery(graphql`
    { siteData { siteData { siteSettings } } }
  `);

  const dealerInfo = JSON.parse(data.siteData.siteData.siteSettings).dealerInfo;

  console.log("[ASC] initAscDataLayer with dealerInfo:", dealerInfo);

  initAscDataLayer({
    measurementIds: (dealerInfo.ga4Id || "").split(",").map(s => s.trim()).filter(Boolean),
    storeName: dealerInfo.dealerName,
    oemBrand:  dealerInfo.manufacturer
  });

  return <>{children}</>;
}